@file:kotlin.js.JsExport
package com.narbase.letsgo.web.routing.domain.passenger.voiceassistant

import com.narbase.letsgo.dto.DtoName
import com.narbase.letsgo.router.EndPoint
import com.narbase.letsgo.web.dto.voiceassistant.CurrentLocationDto
import com.narbase.letsgo.web.dto.voiceassistant.VoiceAssistantInterpretationDto
import com.narbase.letsgo.web.models.voiceassistant.VoiceAssistantField

object InterpretVoiceAssistantSpeechEndpoint :
    EndPoint<InterpretVoiceAssistantSpeechEndpoint.Request, InterpretVoiceAssistantSpeechEndpoint.Response>() {
    class Request(
        val sessionId: String,
        @Suppress("NON_EXPORTABLE_TYPE") val field: DtoName<VoiceAssistantField>,
        val audioBase64: String?,
        val audioMimeType: String?,
        val languageCode: String?,
        val currentLocation: CurrentLocationDto? = null,
    )

    class Response(
        val interpretation: VoiceAssistantInterpretationDto,
        val canTryAgain: Boolean,
    )
}
